import { SelectBox, Tabs } from "devextreme-react";
import React, { useRef, useState } from "react";
import Configuration from "./Configuration";
import Info from "./Info";
import SiteContract from "./SiteContract";
import IRB from "./IRB";
import SiteVisits from "./SiteVisits";
import SafetyReporting from "./SafetyReporting";
import SalesContract from "./SalesContract";
import { useSelector } from "react-redux";
import { updateBasicInfo } from "./Redux/sales";
import ProjectDropDownBox from "../Payment/PaymentStatus/PaymentForm/ProjectDropDownButtonBox";
import IRBProjectStatus from "./IRBProjectStatus";

export default function Sales() {
  const projectDropDownBoxRef = useRef(null);

  const sales = useSelector((state) => state.sales);

  const [cTab, setCTab] = useState("info");

  const [dataSource, setDataSource] = useState([
    // {
    //   type: "configuration",
    //   icon: "preferences",
    // },
    // {
    //   type: "contrNo",
    // },
    {
      text: "INFO",
      type: "info",
    },
    {
      text: "Sales",
      type: "sales",
    },
    {
      text: "Site Contract",
      type: "siteContract",
    },
    {
      text: "IRB",
      type: "IRB",
    },
    {
      text: "Site Visits",
      type: "siteVisits",
    },
    {
      text: "Safety Reporting",
      type: "safetyReporting",
    },
  ]);

  const itemRender = (e) => {
    return (
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          color: "black",
          textTransform: "none",
        }}
      >
        {e.icon && <i className="dx-icon-preferences" />}
        {e.text}
        {/* {e.type == "contrNo" && (
          <ProjectDropDownBox
            projectDropDownBoxRef={projectDropDownBoxRef}
            data={sales}
            updateBasicInfo={updateBasicInfo}
          />
        )} */}
      </div>
    );
  };

  const onItemClick = (e) => {
    if (e.itemData.type != "contrNo") {
      setCTab(e.itemData.type);
    }
  };

  return (
    <>
      <div
        style={{
          width: "180px",
          float: "left",
          marginRight: "10px",
          marginTop: "8px",
        }}
      >
        <ProjectDropDownBox
          type={"sales"}
          projectDropDownBoxRef={projectDropDownBoxRef}
          data={sales}
          updateBasicInfo={updateBasicInfo}
        />
      </div>
      <Tabs
        dataSource={dataSource}
        defaultSelectedIndex={0}
        height={40}
        width={"auto"}
        itemRender={itemRender}
        onItemClick={onItemClick}
      />

      <div
        style={{
          height: "16px",
        }}
      />
      {cTab == "configuration" ? (
        <Configuration />
      ) : cTab == "info" ? (
        <Info sales={sales} />
      ) : cTab == "sales" ? (
        <SalesContract sales={sales} />
      ) : cTab == "siteContract" ? (
        <SiteContract sales={sales} />
      ) : cTab == "IRB" ? (
        // <IRB sales={sales} />
        <IRBProjectStatus sales={sales} />
      ) : cTab == "siteVisits" ? (
        <SiteVisits sales={sales} />
      ) : cTab == "safetyReporting" ? (
        <SafetyReporting sales={sales} />
      ) : (
        <Info />
      )}
    </>
  );
}
